module.exports = __webpack_public_path__ + "static/media/work-img3.dabae3d7.jpg";